module.exports = __webpack_public_path__ + "img/part3-bg-icon2.26165184.png";